module.exports = __webpack_public_path__ + "img/manda_028.219919ed.png";